import { CartActions } from '../cart/types';
import { WishlistActions } from '../wishlist/types';

export type NotificationPayload = {
  name?: string;
  count?: number;
};

export enum NotificationPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface INotification {
  name: CartActions | WishlistActions;
  position?: NotificationPosition;
  payload: NotificationPayload;
}

export interface INotificationWithId extends INotification {
  id: string;
}

export interface NotificationState {
  pushNotification: (notification: INotification) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
  notifications: INotificationWithId[];
}
